import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import ContentOverlay from '../../ContentOverlay/ContentOverlay';

const bem = new BEMHelper('CompanyInformation');

interface CompanyInformationProps {
    messages?: {
        companyInformation: {
            button: () => React.ReactNode;
            title: () => React.ReactNode;
        };
    };
    className: string;
}

function CompanyInformation({ className, messages }: CompanyInformationProps) {
    return (
        <div className={bem(null, null, className)}>
            <ContentOverlay componentKey={'company-information'} buttonLabel={messages?.companyInformation?.button()} titleLabel={messages?.companyInformation?.title()} overlayTypeModifier={'modalCompanyInfoPosition'} modifiers={{ buttonModifier: 'companyInfoButton', textModifier: 'companyInfoText' }} dataTestId='company-info' />
        </div>
    );
}

export default CompanyInformation;
